module.exports = __webpack_public_path__ + "img/images2.3734608a.jpg";